









import {Prop, Vue, Component} from "vue-property-decorator";

@Component({})
export default class KInput extends Vue {
    @Prop({default: "text"}) public type!: string;
    @Prop() public label!: string;
    @Prop() public name!: string;
    @Prop() public size!: string;
    @Prop() public list!: string;
    @Prop() public value!: string;
    @Prop({default: false}) public labelVisible!: boolean;

    protected updateValue() {
        this.$emit("input", (this.$refs.nativeInput as HTMLInputElement).value);
    }
}
